import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilterSaleDiscount,
  reportFilterSaleDiscountSelector,
  reportSaleDiscountOptionsSelector,
} from '../../../state';
import { Discount } from '../../../types';
import { MultiSelect } from '../../selects';

const SaleDiscountFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const discountResource = useSelector(reportSaleDiscountOptionsSelector);
  const { data, loading } = discountResource;
  const discount = useSelector(reportFilterSaleDiscountSelector);

  const disabled = !discountResource.loaded;

  const handleChange = useCallback(
    (value: Discount[]) => {
      dispatch(changeFilterSaleDiscount(value));
    },
    [dispatch]
  );

  const options = useMemo(() => data, [data]);

  return (
    <MultiSelect
      label={t('toolbar.labels.sale_discount')}
      propDesc="description"
      options={options}
      disabled={disabled}
      value={discount}
      onChange={handleChange}
      loading={loading}
    />
  );
};

export default SaleDiscountFilter;
